import React, { useEffect, useRef } from "react";
import {
  TextContainer,
  Paragraph,
} from "../styles/components/Global/Paragraph";
import animations from "./Animations";

const ParagraphText = ({
  text,
  width = "large",
  align = "left",
  size = "normal",
  bold = false,
  indent = false,
  padding = false,
  margin = false,
  parallax = true,
  style = "normal",
}) => {
  const containerRef = useRef(null);
  useEffect(() => {
    if (parallax) {
      setTimeout(() => {
        animations.parallax(containerRef.current);
      }, 1000);
    }
  }, []);

  return (
    <TextContainer ref={containerRef} $padding={padding} $flex>
      <Paragraph
        $width={width}
        $size={size}
        $bold={bold}
        $align={align}
        $indent={indent}
        $margin={margin}
        $style={style}
        dangerouslySetInnerHTML={{ __html: text }}
      ></Paragraph>
    </TextContainer>
  );
};

export default ParagraphText;
